import React, { Component } from 'react';
import PendingJobView from './PendingJobView';
import { url } from '../../../Server/url/GlobalUrl';

class PendingJobComponent extends Component {
  state = {
    data: [],
    expand: 'block',
    expand_id: '',
    modal_show: false,
    authResponse: '',
    list_active: '',
    card_active: 'active',
    card: true,
    apply_modal_show: false,
    applied_job_id: '',
    applied_shift_id: '',
    shift_select_timing: [],
    qualification: [],
  };

  handelShift = (id) => {
    console.log('shift  id', id);
    this.setState({ applied_shift_id: id });
  };

  applyHideCustomModal = () => {
    this.setState({ apply_modal_show: false });
  };

  hideCustomModal = () => {
    this.setState({ modal_show: false });
  };

  showCustomModal = () => {
    this.setState({ modal_show: true });
  };

  acceptJobModal = (id) => {
    if (localStorage.getItem('token')) {
      let auth = localStorage.getItem('token');
      fetch(url + '/jobs/pending-jobs/', {
        method: 'POST',
        body: JSON.stringify({
          shift_id: id,
          accepted: 'true',
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
      })
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            console.log('Data', this.state.data);
            var dt = this.state.data.filter((data) => {
              return data.job != id;
            });
            console.log(dt, 'ths is ');
            this.setState({ data: dt });
            this.showCustomModal();
            this.setState({ authResponse: 'Job accepted Successfully.' });
            // window.location.reload();
          } else {
            this.showCustomModal();
            this.setState({ authResponse: 'Something went wrong!' });
            return res.json();
          }
        })
        .then((res) => console.log(res))

        .catch((err) => {
          this.showCustomModal();
          this.setState({ authResponse: 'Something went wrong!' });
        });
    } else {
      window.location.replace('/login');
    }
  };

  declineJobModal = (id, shift) => {
    console.log('id', id);
    if (localStorage.getItem('token')) {
      let auth = localStorage.getItem('token');
      fetch(url + '/jobs/pending-jobs/', {
        method: 'POST',
        body: JSON.stringify({
          shift_id: id,
          accepted: 'false',
        }),
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
      })
        .then((res) => {
          if (res.status == 200 || res.status == 201) {
            console.log('Data', this.state.data);
            var dt = this.state.data.filter((data) => {
              return data.job != id;
            });
            console.log(dt, 'ths is ');
            this.setState({ data: dt });
            this.showCustomModal();
            this.setState({ authResponse: 'Job declined Successfully.' });
            window.location.reload();
          } else {
            this.showCustomModal();
            this.setState({ authResponse: 'Something went wrong!' });
            return res.json();
          }
        })
        .then((res) => console.log(res))

        .catch((err) => {
          this.showCustomModal();
          this.setState({ authResponse: 'Something went wrong!' });
        });
    } else {
      window.location.replace('/login');
    }
  };

  componentDidMount() {
    let auth = localStorage.getItem('token');
    let user = localStorage.getItem('cv-id');

    fetch(url + '/jobs/qualification/', {
      method: 'GET',
    })
      .then((res) => res.json())
      .then(
        (result) => {
          this.setState({ qualification: result });
          console.log('qualification', result);
        },
        (error) => {
          console.log('error', error);
        }
      );

    fetch(url + '/jobs/pending-jobs/', {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: 'Bearer ' + auth,
      },
    })
      .then((response) => {
        // console.log("Response", response.json())
        return response.json();

        // console.log(this.state.data);
        if (response['status'] === 201 || response['status'] === 200) {
        }
      })
      .then((data) => {
        if (data) {
          this.setState({ data: data });
          console.log(data);
        }
      })

      .catch((err) => {
        console.log('ERROR', err.body);
      });
  }
  handelcompression = (id) => {
    console.log('id', id);
    if (this.state.expand_id === id) {
      if (this.state.expand == 'block') {
        this.setState({ expand: 'none' });
        this.setState({ expand_id: id });
      } else {
        this.setState({ expand: 'block' });
      }
    } else {
      this.setState({ expand: 'block' });
      this.setState({ expand_id: id });
    }
  };

  applyjob = async () => {
    let id = this.state.applied_job_id;
    this.applyHideCustomModal();
    console.log('shift id', this.state.applied_shift_id);
    console.log('job id', this.state.applied_job_id);
    if (localStorage.getItem('token')) {
      let data = {
        job: this.state.applied_job_id,
        shift: this.state.applied_shift_id,
      };
      let auth = localStorage.getItem('token');
      await fetch(url + '/jobs/user-applied-jobs/', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          Authorization: 'Bearer ' + auth,
        },
        body: JSON.stringify(data),
      })
        .then((response) => {
          console.log('response', response);
          if (response['status'] === 201 || response['status'] === 200) {
            this.showCustomModal();
            this.setState({
              authResponse: 'You Have applied to job successfully ',
            });
            return response.json();
          } else if (response['status'] === 400 || response['status'] === 401) {
            this.showCustomModal();
            this.setState({
              authResponse: 'Some thing went wrong please try again ',
            });
          }
          return response.json();
        })
        .then((result) => {
          console.log('result', result);
          if (result.error) this.setState({ authResponse: `${result.error}` });
        });
    } else {
      window.location.replace('/login');
    }
  };

  return_string_data = (ids) => {
    console.log(ids);
    if (!ids) {
      return;
    }
    var result = [];
    for (var each of this.state.qualification) {
      for (var id of ids) {
        if (each.id == id) {
          // console.log(id,each.id);
          if (!result.includes(each.type)) {
            result.push(each.type);
          }
        }
      }
    }
    return result.join(',');
  };

  handelFormat = () => {
    console.log('yes i am in');
    if (this.state.card) {
      this.setState({
        card: false,
        list_active: 'active',
        card_active: '',
      });
    } else {
      this.setState({
        card: true,
        card_active: 'active',
        list_active: '',
      });
    }
  };

  render() {
    console.log('INSIDE ACCEPTED JOB');
    return (
      <PendingJobView
        data={this.state.data}
        expand_id={this.state.expand_id}
        expand={this.state.expand}
        modal_show={this.state.modal_show}
        authResponse={this.state.authResponse}
        handelFormat={this.handelFormat}
        card={this.state.card}
        card_active={this.state.card_active}
        list_active={this.state.list_active}
        showCustomModal={this.showCustomModal}
        hideCustomModal={this.hideCustomModal}
        applyjob={this.applyjob}
        return_string_data={this.return_string_data}
        shift_select_timing={this.state.shift_select_timing}
        acceptJobModal={this.acceptJobModal}
        declineJobModal={this.declineJobModal}
        applyHideCustomModal={this.applyHideCustomModal}
        handelcompression={this.handelcompression}
      />
    );
  }
}

export default PendingJobComponent;
